import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function RootRedirect() {
  const { isAuthenticated, isAuthReady } = useAuth();

  if (!isAuthReady) {
    return null;
  }

  return <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />;
}
